module.exports = __webpack_public_path__ + "img/dui.a7eee391.png";